"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserialize = void 0;
const utils_1 = require("./utils");
/**
 * Deserialize a JSON:API response
 *
 * @param response
 * @param options
 */
function deserialize(response, options = {}) {
    if (!response.data) {
        return undefined;
    }
    const included = response.included || [];
    return Array.isArray(response.data)
        ? response.data.map((data) => {
            return parseJsonApiSimpleResourceData(data, included, options, false, {});
        })
        : parseJsonApiSimpleResourceData(response.data, included, options, false, {});
}
exports.deserialize = deserialize;
function parseJsonApiSimpleResourceData(data, included, options, useCache, includedCache) {
    if (!(data.type in includedCache)) {
        includedCache[data.type] = {};
    }
    const id = data.id || undefined;
    if (useCache && id && id in includedCache[data.type]) {
        return includedCache[data.type][id];
    }
    let attributes = data.attributes || {};
    if (options.changeCase) {
        attributes = (0, utils_1.changeCase)(attributes, options.changeCase, options.changeCaseDeep);
    }
    const resource = Object.assign(Object.assign({}, (id ? { id } : {})), attributes);
    if (id) {
        includedCache[data.type][id] = resource;
    }
    if (data.relationships) {
        for (const relationName of Object.keys(data.relationships)) {
            const relationReference = data.relationships[relationName];
            if (!relationReference) {
                continue;
            }
            if (Array.isArray(relationReference.data)) {
                resource[relationName] = relationReference.data.map((relationData) => {
                    return findJsonApiIncluded(included, includedCache, relationData.type, relationData.id, options);
                });
            }
            else if (relationReference && relationReference.data) {
                resource[relationName] = findJsonApiIncluded(included, includedCache, relationReference.data.type, relationReference.data.id, options);
            }
        }
    }
    return resource;
}
/**
 *
 * @param included
 * @param includedCache
 * @param type
 * @param id
 * @param options
 */
function findJsonApiIncluded(included, includedCache, type, id, options) {
    const foundResource = included.find((item) => item.type === type && item.id === id);
    if (!foundResource) {
        return { id };
    }
    return parseJsonApiSimpleResourceData(foundResource, included, options, true, includedCache);
}
